/**
 * Subscription Cancel Page
 *
 * Displayed when user cancels Stripe checkout. Provides option
 * to return to dashboard or try subscribing again.
 *
 * @since 1.0.0
 */
import { createFileRoute, Link } from "@tanstack/react-router";
import { showPaywall } from "~/lib/atoms/paywall.ts";

export const Route = createFileRoute("/flirtmachine/subscription/cancel")({
  component: SubscriptionCancel,
});

/**
 * SubscriptionCancel component
 *
 * Shows message when checkout was cancelled and provides
 * options to retry or continue to dashboard.
 *
 * @since 1.0.0
 */
function SubscriptionCancel() {
  const handleTryAgain = () => {
    void showPaywall();
  };

  return (
    <div className="min-h-screen bg-zinc-950 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-xl p-8 text-center">
        {/* Cancel Icon */}
        <div className="mx-auto mb-6 flex size-16 items-center justify-center rounded-full bg-gray-100">
          <svg
            className="size-8 text-gray-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </div>

        {/* Header */}
        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          Checkout Cancelled
        </h1>
        <p className="text-gray-600 mb-6">
          No worries! Your checkout was cancelled and you haven't been charged.
        </p>

        {/* Actions */}
        <div className="space-y-3">
          <button
            onClick={handleTryAgain}
            className="w-full py-3 px-4 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors"
          >
            Try Again
          </button>

          <Link
            to="/flirtmachine/dashboard"
            className="block w-full py-3 px-4 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium rounded-lg transition-colors"
          >
            Go to Dashboard
          </Link>
        </div>

        {/* Help Text */}
        <p className="mt-6 text-sm text-gray-500">
          Questions? Contact us at support@flirtmachine.app
        </p>
      </div>
    </div>
  );
}
